// extracted by mini-css-extract-plugin
export var cards = "workshops-module--cards--4u9Pz";
export var card = "workshops-module--card--6qSp3";
export var text = "workshops-module--text--YSs7j";
export var dateText = "workshops-module--date-text--qOiaw";